<script setup lang="ts">
    import { CONTACT_IMPORT_COLUMN_ROWS, ContactImportErrorKind, ContactImportErrors } from '~~/app/contact/import/contact-import';

    const props = defineProps<{
        errors: ContactImportErrors;
    }>();

    const { t } = useTranslation();

    const MESSAGE_KEYS: Record<ContactImportErrorKind, string> = {
        invalid_file_type: 'contact.contact.import_form.errors.invalid_file_type',
        invalid_file: 'contact.contact.import_form.errors.invalid_file',
        invalid_content: 'contact.contact.import_form.errors.invalid_content',
        request_failed: 'toasts.error',
    };

    const expectedColumns = computed(() =>
        CONTACT_IMPORT_COLUMN_ROWS.flat()
            .map((column) => t(`contact.contact.import_form.content.file.${column}`))
            .join(', ')
    );
</script>

<template>
    <div class="w-full p-4 mb-4 text-sm text-white bg-red-600 rounded text-left space-y-2 max-h-[500px] overflow-y-auto">
        <p>{{ t(MESSAGE_KEYS[props.errors.kind]) }}</p>
        <template v-if="props.errors.kind === 'invalid_content'">
            <p>{{ t('contact.contact.import_form.errors.expected_columns') }}</p>
            <p class="font-semibold">{{ expectedColumns }}</p>
        </template>
        <!-- Only the content errors have their own help text. For the others, the API message is the useful part. -->
        <details
            v-if="props.errors.details.length"
            :open="props.errors.kind !== 'invalid_content'"
        >
            <summary class="cursor-pointer">{{ t('contact.contact.import_form.errors.show_details') }}</summary>
            <p
                v-for="(detail, index) in props.errors.details"
                :key="index"
                class="mt-1"
            >
                <span
                    v-if="detail.line"
                    class="mr-2"
                    >{{ t('import_form.error_line_number', { number: detail.line }) }}:</span
                >
                <span>{{ detail.message }}</span>
            </p>
        </details>
    </div>
</template>
